import * as React from 'react';
import { SVGProps } from 'react';

const IconMaxWidthSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 2h1v3.5l2-2v2h6v-2l2 2V2h1v8h-1V6.5l-2 2v-2H3v2l-2-2V10H0V2z" />
  </svg>
);
export default IconMaxWidthSizeXs;
